/*
 * Dekamund-endring (ScandiCommerce, 2026-09-09)
 * ---------------------------------------------
 * Bakgrunnsvideoene lastes i 1080p (målt til 7,2 Mbps på forsiden).
 * Liquid eksponerer ingen mindre kilde, så i stedet for å tvinge
 * mobilbrukere gjennom nedlastingen viser vi plakatbildet der.
 *
 * Under 768px: videoen fjernes og .lazy-video-fallback vises.
 * Over 768px: uendret oppførsel - lazy-lasting når elementet er i syne.
 */
const DEKAMUND_VIDEO_MIN_WIDTH = 768;

class LazyVideo extends HTMLElement {
  constructor() {
    super();
  }

  showFallback() {
    const videoElement = this.querySelector('video');
    const videoFallback = this.querySelector('.lazy-video-fallback');

    if (videoElement) videoElement.remove();
    if (videoFallback) videoFallback.style.display = 'block';
  }

  connectedCallback() {
    const isSmallScreen =
      typeof window.matchMedia === 'function' &&
      window.matchMedia(`(max-width: ${DEKAMUND_VIDEO_MIN_WIDTH - 1}px)`).matches;

    if (isSmallScreen) {
      this.showFallback();
      return;
    }

    const self = this;

    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer,
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.querySelectorAll('source')) {
            var videoSource = video.target.querySelectorAll('source')[source];
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          var videoElement = video.target.querySelector('video');

          videoElement.load();

          //detect low power mode and show fallback image
          videoElement.play().catch((error) => {
            if (error.name === 'NotAllowedError') {
              self.showFallback();
            }
          });

          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideoObserver.observe(this);
  }
}

customElements.define('lazy-video', LazyVideo);
